
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fUwgh", function(module, exports) {
/* InconsistentLicenseFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $9hlns = parcelRequire("9hlns");


var $3sFtD = parcelRequire("3sFtD");


var $7aRa9 = parcelRequire("7aRa9");


var $3IBnw = parcelRequire("3IBnw");


var $e4o8D = parcelRequire("e4o8D");


var $aJv6Q = parcelRequire("aJv6Q");


var $6mKj3 = parcelRequire("6mKj3");

/**
 * @generated SignedSource<<11e802bf14ecb2a73527f485a5bff21a>>
 * @relayHash 6157ca61a6336b3422076fe92ddce48f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7efa98fd3ab9cf491fd7115472ff73b713b1485891b7a8da3895b6164a4efad8
const $f825243313932fba$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessStatus"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsInconsistentLicenseQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsInconsistentLicenseQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "6157ca61a6336b3422076fe92ddce48f",
            "id": "7efa98fd3ab9cf491fd7115472ff73b713b1485891b7a8da3895b6164a4efad8",
            "metadata": {},
            "name": "useIsInconsistentLicenseQuery",
            "operationKind": "query",
            "text": "query useIsInconsistentLicenseQuery{user:confluence_atlassianUser(current:true){id,confluence{accessStatus}}}"
        }
    };
}();
$f825243313932fba$var$node.hash = "9a564a9cef3c3d68d5077a747c253865";
var $f825243313932fba$export$2e2bcd8739ae039 = $f825243313932fba$var$node;






var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");

const $bdb6865325407c1d$var$BULK_PERMITTED_API = '/gateway/api/permissions/bulk/permitted';
const $bdb6865325407c1d$var$LICENSED_STATUSES = new Set([
    (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS,
    (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS,
    (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS
]);
const $bdb6865325407c1d$var$isLicensedStatus = (accessStatus)=>!!accessStatus && $bdb6865325407c1d$var$LICENSED_STATUSES.has(accessStatus);
const $bdb6865325407c1d$var$CONFLUENCE_ACCESS_STATUS_QUERY = (0, $f825243313932fba$export$2e2bcd8739ae039);
const $bdb6865325407c1d$var$makeSiteAri = (cloudId)=>`ari:cloud:confluence::site/${cloudId}`;
const $bdb6865325407c1d$var$makePermsRequestBody = (cloudId)=>JSON.stringify([
        {
            permissionId: 'write',
            resourceId: $bdb6865325407c1d$var$makeSiteAri(cloudId)
        },
        {
            permissionId: 'external-collaborator-write',
            resourceId: $bdb6865325407c1d$var$makeSiteAri(cloudId)
        }
    ]);
const $bdb6865325407c1d$export$b0c935905dc4c9a8 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLoggedIn: isLoggedIn, accessStatus: sessionDataAccessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [allowPolling, setAllowPolling] = (0, $42omo.useState)(false);
    const { data: data, error: error, startPolling: startPolling, stopPolling: stopPolling } = (0, $jMyy4.useQueryInterop)($bdb6865325407c1d$var$CONFLUENCE_ACCESS_STATUS_QUERY, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        skip: !isLoggedIn || $bdb6865325407c1d$var$isLicensedStatus(sessionDataAccessStatus) || !allowPolling
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    const latestAccessStatus = data?.user?.confluence?.accessStatus ?? sessionDataAccessStatus;
    const isLicensedInConfluence = $bdb6865325407c1d$var$isLicensedStatus(latestAccessStatus);
    const [isLicensedInIdentity, setIsLicensedInIdentity] = (0, $42omo.useState)(false);
    const isInconsistentLicense = !isLicensedInConfluence && isLicensedInIdentity;
    /** Determine user's license status in Identity */ (0, $42omo.useEffect)(()=>{
        /** No point to run any of this if user is already licensed in Confluence */ if (!isLoggedIn || !cloudId || isLicensedInConfluence) return;
        const callIdentityPerms = async ()=>{
            try {
                const response = await (0, $f7B1p.cfetch)($bdb6865325407c1d$var$BULK_PERMITTED_API, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: $bdb6865325407c1d$var$makePermsRequestBody(cloudId)
                });
                if (response.ok) {
                    const result = await response.json();
                    const isLicensedInIdentity = result.some((entry)=>entry.permitted);
                    setIsLicensedInIdentity(isLicensedInIdentity);
                } else throw new (0, $hBkCm.BadStatusError)(`${response.status}: ${response.statusText}`, response);
            } catch (e) {
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'inconsistentLicenseCheck',
                        action: 'failed',
                        actionSubject: 'callIdentityPerms',
                        attributes: {
                            status: (0, $hBkCm.BadStatusError).isBadStatusError(e) ? e.response.status : 'unknown',
                            statusText: (0, $hBkCm.BadStatusError).isBadStatusError(e) ? e.response.statusText : 'unknown',
                            message: e instanceof Error ? e.message : 'unknown'
                        }
                    }
                }).fire();
            }
        };
        callIdentityPerms();
    }, [
        isLoggedIn,
        cloudId,
        isLicensedInConfluence,
        createAnalyticsEvent
    ]);
    /** Only poll when there are discrepancies in the license */ (0, $42omo.useEffect)(()=>{
        if (isInconsistentLicense) {
            setAllowPolling(true);
            startPolling(10000);
        } else stopPolling();
    }, [
        isInconsistentLicense,
        startPolling,
        stopPolling
    ]);
    /** Definitely stop polling on unmount */ (0, $42omo.useEffect)(()=>{
        return ()=>stopPolling();
    }, [
        stopPolling
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isInconsistentLicense) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'foundInconsistency',
                actionSubject: 'inconsistentLicenseCheck',
                source: 'inconsistentLicenseCheck',
                attributes: {
                    sessionDataAccessStatus: sessionDataAccessStatus,
                    latestAccessStatus: latestAccessStatus,
                    isLicensedInIdentity: isLicensedInIdentity,
                    cloudId: cloudId
                }
            }
        }).fire();
    }, [
        isInconsistentLicense,
        isLicensedInIdentity,
        createAnalyticsEvent,
        sessionDataAccessStatus,
        latestAccessStatus,
        cloudId
    ]);
    return {
        isInconsistentLicense: isInconsistentLicense
    };
};


const $27ee2f74c082a460$var$i18n = (0, $h82at.defineMessages)({
    licenseProcessingTitle: {
        id: "inconsistent-license.flag.license-processing-title.ai-non-final",
        defaultMessage: "You have a license processing"
    },
    licenseProcessingDescription: {
        id: "inconsistent-license.flag.license-processing-description.ai-non-final",
        defaultMessage: "While it's processing, your Confluence access is limited. We'll let you know when it's active and you can refresh with full access."
    },
    licenseActiveTitle: {
        id: "inconsistent-license.flag.license-active-title.ai-non-final",
        defaultMessage: "Your Confluence license is now active"
    },
    licenseActiveDescription: {
        id: "inconsistent-license.flag.license-active-description.ai-non-final",
        defaultMessage: "Your license has finished processing. Refresh to experience full licensed access."
    },
    refreshActionLabel: {
        id: "inconsistent-license.flag.refresh-action-label.ai-non-final",
        defaultMessage: "Refresh"
    }
});
const $27ee2f74c082a460$var$RELOAD = ()=>window?.location.reload();
const $27ee2f74c082a460$var$INCONSISTENT_LICENSE_WARNING_FLAG_ID = 'INCONSISTENT_LICENSE_WARNING_FLAG_ID';
const $27ee2f74c082a460$var$LICENSE_CONSISTENT_SUCCESS_FLAG_ID = 'LICENSE_CONSISTENT_SUCCESS_FLAG_ID';
const $27ee2f74c082a460$var$spinnerContainerStyles = null;
const $27ee2f74c082a460$var$closeButtonCoverStyles = null;
const $27ee2f74c082a460$export$175a0752098bbb87 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { isInconsistentLicense: isInconsistentLicense } = (0, $bdb6865325407c1d$export$b0c935905dc4c9a8)();
    const [inconsistentLicenseWarningFlagShown, setInconsistentLicenseWarningFlagShown] = (0, $42omo.useState)(false); /** Show inconsistent license warning flag */ 
    (0, $42omo.useEffect)(()=>{
        if (!isInconsistentLicense) return;
        const showFlag = async ()=>flags.showCustomFlag({
                isAutoDismiss: false,
                customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null),
                id: $27ee2f74c082a460$var$INCONSISTENT_LICENSE_WARNING_FLAG_ID,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_kqswh2mm"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_11q71bhr _1bsbzwfg _4t3izwfg _kqswstnw _1ltv1mjv _154i1bs0 _1pbykb7n _11i2glyw"
                    ])
                }), formatMessage($27ee2f74c082a460$var$i18n.licenseProcessingTitle)),
                description: formatMessage($27ee2f74c082a460$var$i18n.licenseProcessingDescription),
                onClose: showFlag
            });
        showFlag();
        setInconsistentLicenseWarningFlagShown(true);
    }, [
        isInconsistentLicense,
        flags,
        formatMessage
    ]); /** Show license consistent flag */ 
    (0, $42omo.useEffect)(()=>{
        const replaceWarningFlagWithSuccessFlag = async ()=>{
            await flags.hideFlag($27ee2f74c082a460$var$INCONSISTENT_LICENSE_WARNING_FLAG_ID);
            await flags.showCustomFlag({
                isAutoDismiss: false,
                customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                    color: "var(--ds-icon-success, #6A9A23)",
                    label: ""
                }),
                id: $27ee2f74c082a460$var$LICENSE_CONSISTENT_SUCCESS_FLAG_ID,
                title: formatMessage($27ee2f74c082a460$var$i18n.licenseActiveTitle),
                description: formatMessage($27ee2f74c082a460$var$i18n.licenseActiveDescription),
                actions: [
                    {
                        content: formatMessage($27ee2f74c082a460$var$i18n.refreshActionLabel),
                        onClick: $27ee2f74c082a460$var$RELOAD
                    }
                ]
            });
        };
        if (inconsistentLicenseWarningFlagShown && !isInconsistentLicense) replaceWarningFlagWithSuccessFlag();
    }, [
        isInconsistentLicense,
        inconsistentLicenseWarningFlagShown,
        flags,
        formatMessage
    ]);
    return null;
});
const $27ee2f74c082a460$export$d8ac8ae6df997787 = ()=>{
    const isSSR = (0, $e4o8D.useRenderServerPlaceholder)();
    if (isSSR || !(0, $6mKj3.expValEquals)('cc_fe_inconsistent_license_warning', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27ee2f74c082a460$export$175a0752098bbb87, null);
};
const $27ee2f74c082a460$export$9bfc14d39c192dcd = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($27ee2f74c082a460$export$d8ac8ae6df997787);
module.exports["InconsistentLicenseFlagInternal"] = $27ee2f74c082a460$export$175a0752098bbb87;
module.exports["InconsistentLicenseFlagComponent"] = $27ee2f74c082a460$export$d8ac8ae6df997787;
module.exports["InconsistentLicenseFlag"] = $27ee2f74c082a460$export$9bfc14d39c192dcd;

});


//# sourceMappingURL=InconsistentLicenseFlag.7e1a493d.js.map
